(function() {

  var SEC_PER_DAY = 86400;

  function parseJSONSafe(value) {
    if (!value) return null;
    try {
      return typeof value === 'string' ? JSON.parse(value) : value;
    } catch (err) {
      return null;
    }
  }

  function toNumber(val) {
    var num = parseInt(val, 10);
    return isNaN(num) ? 0 : num;
  }

  function escapeHtml(value) {
    return (value || '').toString()
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');
  }

  function normalizeRegion(region) {
    var val = (region || '').toString().toUpperCase();
    if (val === 'US' || val === 'USA' || val === 'UNITED STATES') return 'US';
    if (val === 'CA' || val === 'CANADA') return 'CA';
    return val || 'BOTH';
  }

  function bumpWeekend(ts, holidaySet) {
    var date = new Date(ts * 1000);
    var dow = date.getDay();

    if (!holidaySet) {
      if (dow === 6) {
        date.setDate(date.getDate() + 2);
      } else if (dow === 0) {
        date.setDate(date.getDate() + 1);
      }
      return Math.floor(date.getTime() / 1000);
    }

    // v3, calendar present: skip weekends AND our closure dates, cascading.
    var guard = 0;
    while (guard++ < 21) {
      dow = date.getDay();
      var iso = localIsoOf(Math.floor(date.getTime() / 1000));
      if (dow !== 0 && dow !== 6 && holidaySet[iso] !== 1) break;
      date.setDate(date.getDate() + 1);
    }
    return Math.floor(date.getTime() / 1000);
  }

  function countBusinessDaysBetween(startTs, endTs) {
    var startDate = new Date((startTs || Date.now() / 1000) * 1000);
    var endDate = new Date((endTs || startTs || Date.now() / 1000) * 1000);

    startDate = new Date(startDate.getFullYear(), startDate.getMonth(), startDate.getDate());
    endDate = new Date(endDate.getFullYear(), endDate.getMonth(), endDate.getDate());

    if (endDate <= startDate) return 0;

    var businessDays = 0;
    var cursor = new Date(startDate);

    while (cursor < endDate) {
      cursor.setDate(cursor.getDate() + 1);
      var dow = cursor.getDay();
      if (dow !== 0 && dow !== 6) {
        businessDays += 1;
      }
    }

    return businessDays;
  }

  // ---------------------------------------------------------------------
  // ETA v3: Toronto-anchored calendar machinery (Layer A + Layer B).
  // Everything here is INERT unless config.etaCalendar is provided, which the
  // theme only does on the .ca market. See ETA-V3-HANDOFF.md.
  // ---------------------------------------------------------------------
  var TORONTO_FMT = null;
  function torontoParts(ts) {
    if (TORONTO_FMT === null) {
      try {
        TORONTO_FMT = new Intl.DateTimeFormat('en-CA', {
          timeZone: 'America/Toronto',
          year: 'numeric', month: '2-digit', day: 'numeric',
          hour: '2-digit', minute: '2-digit', hour12: false, weekday: 'short'
        });
      } catch (err) { TORONTO_FMT = false; }
    }
    if (!TORONTO_FMT) return null;
    var parts = {};
    TORONTO_FMT.formatToParts(new Date(ts * 1000)).forEach(function (pt) {
      parts[pt.type] = pt.value;
    });
    var dowMap = { Sun: 0, Mon: 1, Tue: 2, Wed: 3, Thu: 4, Fri: 5, Sat: 6 };
    var hour = parseInt(parts.hour, 10);
    if (hour === 24) hour = 0;
    return {
      iso: parts.year + '-' + parts.month + '-' + parts.day,
      dow: dowMap[(parts.weekday || '').slice(0, 3)],
      hour: hour,
      minute: parseInt(parts.minute, 10) || 0
    };
  }

  function isoAddDays(iso, n) {
    var t = Date.parse(iso + 'T00:00:00Z') + n * 86400000;
    return new Date(t).toISOString().slice(0, 10);
  }
  function isoDow(iso) {
    return new Date(Date.parse(iso + 'T00:00:00Z')).getUTCDay();
  }
  function localIsoOf(ts) {
    var d = new Date(ts * 1000);
    var m = d.getMonth() + 1, day = d.getDate();
    return d.getFullYear() + '-' + (m < 10 ? '0' : '') + m + '-' + (day < 10 ? '0' : '') + day;
  }
  function fmtIsoShort(iso) {
    return new Date(iso + 'T12:00:00Z').toLocaleDateString('en-US', {
      timeZone: 'UTC', month: 'short', day: 'numeric', year: 'numeric'
    });
  }
  function fmtIsoLong(iso) {
    return new Date(iso + 'T12:00:00Z').toLocaleDateString('en-US', {
      timeZone: 'UTC', month: 'long', day: 'numeric', year: 'numeric'
    });
  }

  // config.etaCalendar = { onClosed: [ISO...], usClosed: [ISO...] }
  function calendarSets(cal) {
    if (!cal) return null;
    function toSet(arr) {
      var out = {};
      (Array.isArray(arr) ? arr : []).forEach(function (x) {
        if (x) out[String(x).slice(0, 10)] = 1;
      });
      return out;
    }
    return { on: toSet(cal.onClosed), us: toSet(cal.usClosed) };
  }

  // Layer A: nominal Friday ship day -> actual ship day.
  // Decision 10: Friday closure ships Monday, cascading to the next OPEN day.
  // Decision 11: Wednesday RECEIVE closure also ships Monday.
  function resolveShipDay(nomFriIso, recvWedIso, sets) {
    var candidate = nomFriIso;
    if (sets) {
      var monday = isoAddDays(nomFriIso, 3);
      if (recvWedIso && sets.on[recvWedIso] === 1) candidate = monday;
      if (sets.on[nomFriIso] === 1 && monday > candidate) candidate = monday;
      if (sets.on[nomFriIso] === 1 && candidate === nomFriIso) candidate = monday;
      var guard = 0;
      while (guard++ < 21 &&
        (isoDow(candidate) === 0 || isoDow(candidate) === 6 || sets.on[candidate] === 1)) {
        candidate = isoAddDays(candidate, 1);
      }
    }
    return candidate;
  }

  // Layer B: the T14 weekly inbound cycle. PA/IN/TX cut off Friday noon
  // Toronto (+7d to ship); NV cuts off Wednesday noon (+9d). Cutoffs on a
  // closure move EARLIER (decisions 12/13): Friday cutoffs shift on US
  // holidays; the NV Wednesday cutoff shifts on any closure, ours or theirs.
  function computeT14CycleShip(state, nowTs, sets) {
    var tp = torontoParts(nowTs);
    if (!tp || !sets) return null;
    var isNV = state === 'NV';
    var cutDow = isNV ? 3 : 5;
    var shipOffset = isNV ? 9 : 7;
    var recvOffset = isNV ? 7 : 5;
    for (var k = 0; k < 42; k++) {
      var iso = isoAddDays(tp.iso, k);
      if (isoDow(iso) !== cutDow) continue;
      var eff = iso, guard = 0;
      while (guard++ < 7) {
        var closed = isNV
          ? (sets.on[eff] === 1 || sets.us[eff] === 1)
          : (sets.us[eff] === 1);
        if (!closed) break;
        eff = isoAddDays(eff, -1);
      }
      var catches = tp.iso < eff || (tp.iso === eff && tp.hour < 12);
      if (!catches) continue;
      var nominalShip = isoAddDays(iso, shipOffset);
      var receiveIso = isoAddDays(iso, recvOffset);
      var shipIso = resolveShipDay(nominalShip, receiveIso, sets);
      return {
        shipIso: shipIso,
        shipTs: Date.parse(shipIso + 'T16:00:00Z') / 1000,
        nominalCutoff: iso,
        effectiveCutoff: eff,
        receiveIso: receiveIso,
        state: state
      };
    }
    return null;
  }

  function extractField(obj, key) {
    if (!obj) return undefined;
    if (typeof obj[key] !== 'undefined') return obj[key];
    if (obj.value && typeof obj.value[key] !== 'undefined') return obj.value[key];
    if (obj.fields && obj.fields[key]) {
      var f = obj.fields[key];
      if (typeof f.value !== 'undefined') return f.value;
      if (typeof f.reference !== 'undefined') return f.reference;
    }
    return undefined;
  }

  function computeDisplayDate(daysFromToday, startTs, holidaySet) {
    return computeBusinessDisplayDate(daysFromToday, startTs, holidaySet);
  }

  function computeBusinessDisplayDate(businessDaysFromToday, startTs, holidaySet) {
    var date = new Date((startTs || Date.now() / 1000) * 1000);
    var daysAdded = 0;
    var targetBusinessDays = Math.max(0, businessDaysFromToday);

    while (daysAdded < targetBusinessDays) {
      date.setDate(date.getDate() + 1);
      var dow = date.getDay();
      if (dow !== 0 && dow !== 6) {
        if (!holidaySet || holidaySet[localIsoOf(Math.floor(date.getTime() / 1000))] !== 1) {
          daysAdded += 1;
        }
      }
    }

    return bumpWeekend(Math.floor(date.getTime() / 1000), holidaySet);
  }

  function buildInventoryMap(raw, variantId) {
    var parsed = parseJSONSafe(raw) || {};
    var source = parsed && parsed.value ? parsed.value : parsed;

    if (!source || typeof source !== 'object') return {};

    var locations = source.locations;
    if (locations && typeof locations === 'object') return locations;

    var variantKey = typeof variantId === 'undefined' || variantId === null ? null : variantId.toString();
    var variants = source.variants;
    if (variants && typeof variants === 'object' && variantKey) {
      var variantEntry = variants[variantKey] || variants[variantId];
      var variantLocations = variantEntry && (variantEntry.locations || variantEntry);
      if (variantLocations && typeof variantLocations === 'object') return variantLocations;
    }

    var productLocations = source.productLocations;
    if (productLocations && typeof productLocations === 'object') return productLocations;

    return {};
  }

  /* In/out-only stock (owner, 5 Oct 2026). Some brands' Manufacturer Inventory
     sync is a flag, not a count: 1 = in stock, 0 = out of stock (Powerflex).
     The owner ticks "Stock is in/out only (0/1)" (stock_flag_only) on the
     brand's Vendor ETA Assignment metaobject; nothing here names a brand.
     Only the Manufacturer Inventory source is read this way; JRP, our store
     and the other locations keep their real counts. A flagged 1 is shown as
     "In stock at <brand>" and never limits the quantity (FLAG_STOCK_QTY); a
     flagged 0 with no stock anywhere else says "Out of stock at <brand>". */
  var FLAG_STOCK_QTY = 9999;
  /* a checkbox on the brand's Vendor ETA Assignment entry */
  function vendorHasFlag(config, key) {
    var v = ((config && config.vendor) || '').toString().trim().toLowerCase();
    if (!v) return false;
    var list = Array.isArray(config.vendorAssignments) ? config.vendorAssignments : [];
    return list.some(function(entry) {
      if (!entry) return false;
      if ((extractField(entry, 'vendor_name') || '').toString().trim().toLowerCase() !== v) return false;
      var f = extractField(entry, key);
      if (f && typeof f === 'object' && typeof f.value !== 'undefined') f = f.value;
      return f === true || f === 'true' || f === 1 || f === '1';
    });
  }
  function isFlagStockVendor(config) { return vendorHasFlag(config, 'stock_flag_only'); }
  /* Prefer manufacturer stock (owner, 5 Oct 2026; Powerflex): the brand's own
     stock costs us less than a distributor's, so when Manufacturer Inventory
     has it, it is shown and allocated ahead of faster distributor sources
     (JRP, Marcor, MBRP, GrandWest, WheelPros, Turn14). Our own stock (store,
     warehouses, Raptor brand: internal keys raptor_*) still comes first.
     Checkbox prefer_manufacturer_stock on Vendor ETA Assignment. */
  function isPreferMfrVendor(config) { return vendorHasFlag(config, 'prefer_manufacturer_stock'); }
  function sourceRank(c) { return c.own ? 0 : (c.isManufacturerInventorySource ? 1 : 2); }
  function isManufacturerSourceEntry(source) {
    var id = [
      extractField(source, 'key'),
      extractField(source, 'handle'),
      extractField(source, 'internal_key'),
      extractField(source, 'name'),
      extractField(source, 'shopify_location_id')
    ].join('|').toLowerCase();
    return id.indexOf('manufacturer-inventory') !== -1 ||
      id.indexOf('manufacturer inventory') !== -1 ||
      id.indexOf('ford-racing-inventory') !== -1 ||
      id.indexOf('ford racing inventory') !== -1 ||
      id.indexOf('116224393579') !== -1;
  }
  /* true when the flagged brand's Manufacturer Inventory location reads 0
     for this variant (the location must be in the map: no map, no claim) */
  function flagStockIsOut(config) {
    var inv = buildInventoryMap(config.inventoryMap, config.inventoryVariantId);
    var market = config.market === 'US' ? 'US' : 'CA';
    var sources = Array.isArray(config.fulfillmentSources) ? config.fulfillmentSources : [];
    return sources.some(function(src) {
      if (!src || !isManufacturerSourceEntry(src)) return false;
      var en = extractField(src, 'enabled');
      if (!(en === true || en === 1 || en === '1' || en === 'true')) return false;
      var region = normalizeRegion(extractField(src, 'region_visibility'));
      if (!(region === 'BOTH' || region === market)) return false;
      var loc = extractField(src, 'shopify_location_id');
      if (loc == null || typeof inv[loc] === 'undefined') return false;
      return toNumber(inv[loc]) <= 0;
    });
  }

  function selectWarehouses(config) {
  var inventoryByLocation = buildInventoryMap(config.inventoryMap, config.inventoryVariantId);
  var candidates = [];
  var market = config.market === 'US' ? 'US' : 'CA';
  var sources = Array.isArray(config.fulfillmentSources)
    ? config.fulfillmentSources
    : [];

  // --- DEBUG STEP 1: what are we working with? ---
  console.log('[ETA][WH] inventoryByLocation:', inventoryByLocation, 'raw:', config.inventoryMap, 'variantId:', config.inventoryVariantId);
  console.log('[ETA][WH] market:', market);
  console.log('[ETA][WH] fulfillmentSources count:', sources.length);
  // -----------------------------------------------

  sources.forEach(function(source, idx) {
    if (!source) return;
    var enabled = extractField(source, 'enabled');
    if (!(enabled === true || enabled === 1 || enabled === '1' || enabled === 'true')) return;

    var region = normalizeRegion(extractField(source, 'region_visibility'));
    if (!(region === 'BOTH' || region === market)) return;

    var locationId = extractField(source, 'shopify_location_id');
    if (!locationId) return;

    var qty = toNumber(inventoryByLocation[locationId] || 0);
    if (qty <= 0) return;

    var displayAsStore = extractField(source, 'display_as_store');
    var storeLink = extractField(source, 'store_link');
    var fixedDays = toNumber(extractField(source, 'fixed_shipping_days'));
    var bufferDays = toNumber(extractField(source, 'buffer_days'));
    var maxDisplayQty = extractField(source, 'max_display_quantity');
    var combineSameEta = extractField(source, 'combine_quantity_when_same_eta');
    var sourceName = extractField(source, 'name') || extractField(source, 'key') || 'Warehouse';
    var sourceIdentifier = [
      extractField(source, 'key'),
      extractField(source, 'handle'),
      extractField(source, 'internal_key'),
      sourceName,
      locationId
    ].join('|').toLowerCase();
    var isManufacturerInventorySource =
      sourceIdentifier.indexOf('manufacturer-inventory') !== -1 ||
      sourceIdentifier.indexOf('manufacturer inventory') !== -1 ||
      sourceIdentifier.indexOf('ford-racing-inventory') !== -1 ||
      sourceIdentifier.indexOf('ford racing inventory') !== -1 ||
      sourceIdentifier.indexOf('116224393579') !== -1;
    var isExternalWarehouseSource =
      sourceIdentifier.indexOf('wheelpros-us') !== -1 ||
      sourceIdentifier.indexOf('wheelpros us') !== -1 ||
      sourceIdentifier.indexOf('wheelpros_us') !== -1 ||
      sourceIdentifier.indexOf('115961135467') !== -1;

    var etaDays = fixedDays + bufferDays;
    var etaTs = computeDisplayDate(etaDays, config.todayTs, config.holidaySet);
    var flagStock = !!config.flagStock && isManufacturerInventorySource;
    if (flagStock) qty = FLAG_STOCK_QTY;
    var ownSource = (displayAsStore === true || displayAsStore === 'true' || displayAsStore === 1 || displayAsStore === '1') ||
      /(^|\|)raptor[_\- ]/.test(sourceIdentifier);
    candidates.push({
      flagStock: flagStock,
      own: ownSource,
      shipByISO: localIsoOf(etaTs),
      idx: idx,
      etaDays: etaDays,
      etaTs: etaTs,
      qty: qty,
      name: sourceName,
      maxDisplayQty: typeof maxDisplayQty === 'number' ? maxDisplayQty : toNumber(maxDisplayQty),
      combineSameEta: combineSameEta === true || combineSameEta === 'true' || combineSameEta === 1 || combineSameEta === '1',
      displayAsStore: displayAsStore === true || displayAsStore === 'true' || displayAsStore === 1 || displayAsStore === '1',
      storeLink: storeLink,
      isManufacturerInventorySource: isManufacturerInventorySource,
      isExternalWarehouseSource: isExternalWarehouseSource
    });
  });

  // --- DEBUG STEP 1: did we get any candidates at all? ---
  console.log('[ETA][WH] candidates after filtering:', candidates);
  // -------------------------------------------------------

  if (!candidates.length) return null;

  candidates.sort(function(a, b) {
    if (config.preferMfr) {
      var ra = sourceRank(a), rb = sourceRank(b);
      if (ra !== rb) return ra - rb;
    }
    if (a.etaDays === b.etaDays) return a.idx - b.idx;
    return a.etaDays - b.etaDays;
  });

  var best = candidates[0];
  var combinedQty = best.qty;
  if (best.combineSameEta) {
    candidates.forEach(function(entry, i) {
      if (i === 0) return;
      if (entry.etaTs === best.etaTs) {
        combinedQty += entry.qty;
      }
    });
  }

  var qtyToShow = best.maxDisplayQty ? Math.min(combinedQty, best.maxDisplayQty) : combinedQty;
  // Display honesty (Stathis, 7 Aug): when the merchant display cap bites,
  // render "50+" rather than a bare "50", so a capped count never reads as
  // an exact one. Numeric qtyToShow is kept for any consumer doing math.
  var qtyToShowText = best.flagStock ? 'In stock' : String(qtyToShow) + (combinedQty > qtyToShow ? '+' : '');
  var displayDate = new Date(best.etaTs * 1000).toLocaleDateString('en-US', {
    month: 'short',
    day: 'numeric',
    year: 'numeric'
  });

  // --- DEBUG STEP 1: who won? ---
  console.log('[ETA][WH] winner:', {
    name: best.name,
    qty: best.qty,
    combinedQty: combinedQty,
    qtyToShow: qtyToShow,
    etaDays: best.etaDays,
    displayDate: displayDate
  });
  // -------------------------------

  return {
    path: 'warehouse',
    qtyToShow: qtyToShow,
    qtyToShowText: qtyToShowText,
    displayDate: displayDate,
    etaDays: best.etaDays,
    displayAsStore: best.displayAsStore,
    storeLink: best.storeLink,
    isManufacturerInventorySource: best.isManufacturerInventorySource,
    isExternalWarehouseSource: best.isExternalWarehouseSource,
    flagStock: !!best.flagStock,
    best: best,
    candidates: candidates,
    debug: {
      market: market,
      inventoryByLocation: inventoryByLocation,
      candidates: candidates,
      winner: {
        name: best.name,
        shipByISO: best.shipByISO,
        etaDays: best.etaDays,
        etaTs: best.etaTs,
        qty: best.qty,
        qtyToShow: qtyToShow,
        displayDate: displayDate,
        displayAsStore: best.displayAsStore,
        storeLink: best.storeLink,
        isManufacturerInventorySource: best.isManufacturerInventorySource,
        isExternalWarehouseSource: best.isExternalWarehouseSource
      },
      rules: [
        'Only enabled fulfillment sources are considered.',
        'Region visibility must include the current market (' + market + ').',
        'Location must have on-hand quantity.',
        'Lowest ETA wins. If combine_same_eta is true, quantities with matching ETA are combined.'
      ]
    }
  };
}


  function computeTurn14(config) {
    var etaObj = config.turn14 || {};
    var availList = Array.isArray(etaObj.availability) ? etaObj.availability : [];
    if (!availList.length) return null;

    var todayTs = (config.todayTs || Date.now() / 1000);
    var today = new Date(todayTs * 1000);
    var todayStartTs = new Date(today.getFullYear(), today.getMonth(), today.getDate()).getTime() / 1000;
    var marketIsUS = config.market === 'US';

    var buffers = Array.isArray(config.warehouseBuffers) ? config.warehouseBuffers : [];
    function getBuffer(state) {
      if (marketIsUS) return { base: 0, buf: 0 };
      var match = buffers.find(function(b) {
        return b && extractField(b, 'enabled') && extractField(b, 'warehouse_state_code') === state;
      });
      return match
        ? {
            base: toNumber(extractField(match, 'fixed_shipping_days')),
            buf: toNumber(extractField(match, 'buffer_days'))
          }
        : { base: 0, buf: 0 };
    }

    var best = null;
    var anyStock = availList.some(function(entry) {
      if (!entry) return false;
      return toNumber(entry.Quantity || entry.qty) > 0;
    });
    var anyEta = false;
    var hasPastEta = false;
    var hasFutureEta = false;
    var manufacturerStock = toNumber(
      etaObj.manufacturerStock ||
      etaObj.ManufacturerStock ||
      etaObj.manufacturer_stock
    );
    var manufacturerEstimatedShipDate =
      etaObj.manufacturerEstimatedShipDate ||
      etaObj.ManufacturerEstimatedShipDate ||
      etaObj.manufacturerEsd ||
      etaObj.ManufacturerEsd ||
      etaObj.manufacturer_esd ||
      null;
    var manufacturerStockShippingDays = toNumber(config.manufacturerStockShippingDays);
    if (manufacturerStockShippingDays <= 0) manufacturerStockShippingDays = 5;
    var manufacturerBest = null;

    availList.forEach(function(entry) {
      if (!entry) return;
      var qty = toNumber(entry.Quantity || entry.qty);

      // If any source has inventory, only evaluate in-stock sources.
      // This prevents zero-quantity sources from winning the ETA ranking
      // when an in-stock source exists.
      if (anyStock && qty <= 0) return;

      var etaTsRaw = null;
      var etaIsPast = false;
      if (entry.EstimatedShipDate) {
        etaTsRaw = Date.parse(entry.EstimatedShipDate + 'T00:00:00Z') / 1000;
        if (!isNaN(etaTsRaw)) {
          anyEta = true;
          if (etaTsRaw < todayStartTs) {
            hasPastEta = true;
            etaIsPast = true;
          } else {
            hasFutureEta = true;
          }
        }
      }

      // v3 Layer B: in-stock CA units follow the weekly T14 inbound cycle
      // instead of static buffers, when the calendar is present. Fallback to
      // buffers whenever the cycle cannot compute (decision 5).
      //
      // The enabled flag is string-coerced like every other config flag
      // (see the fulfillment-source pattern above). Found the hard way on
      // 8 Aug: a metafield type drift to single_line_text_field made the
      // Liquid render the STRING "false", which is truthy, silently forcing
      // the cycle ON with the kill switch visually off.
      var gvCycleOn = false;
      if (config.t14Cycle) {
        var gvCe = config.t14Cycle.enabled;
        gvCycleOn = gvCe === true || gvCe === 1 || gvCe === '1' || gvCe === 'true';
      }
      if (qty > 0 && !marketIsUS && config.etaCalendarSets && gvCycleOn) {
        var st = (entry.LocationState || '').toString().toUpperCase();
        if (st === 'PA' || st === 'IN' || st === 'TX' || st === 'NV') {
          var cycle = computeT14CycleShip(st, todayTs, config.etaCalendarSets);
          if (cycle) {
            var cycleTotalDays = countBusinessDaysBetween(todayTs, cycle.shipTs);
            // Tie-break on quantity: PA/IN/TX share one weekly cycle and tie
            // to the day, so feed order used to win and the shallowest
            // warehouse's count got displayed (TX's 6 over PA's 32). Prefer
            // the deepest warehouse among equal ship dates; dates unchanged.
            if (!best || cycle.shipTs < best.displayTsNum ||
                (cycle.shipTs === best.displayTsNum && qty > best.qty)) {
              best = {
                totalDays: cycleTotalDays,
                qty: qty,
                displayTsNum: cycle.shipTs,
                shipByISO: cycle.shipIso,
                cycle: cycle,
                displayDate: fmtIsoShort(cycle.shipIso)
              };
            }
            return;
          }
        }
      }

      var baseBusinessDays = null;
      if (qty > 0) {
        baseBusinessDays = 1;
      } else if (etaTsRaw && !etaIsPast) {
        baseBusinessDays = countBusinessDaysBetween(todayTs, etaTsRaw);
      }

      if (baseBusinessDays !== null) {
        var totalDays = baseBusinessDays;
        if (marketIsUS) {
          totalDays += qty > 0 ? toNumber(config.usInStockBuffer) : toNumber(config.usOutOfStockBuffer);
        } else {
          var buf = getBuffer(entry.LocationState);
          totalDays += buf.base + buf.buf;
        }
        var displayTs = computeBusinessDisplayDate(totalDays, todayTs, config.holidaySet);

        // Tie-break on quantity (v6.7), mirroring the cycle branch above. In
        // the US market every in-stock Turn14 warehouse gets the same buffer,
        // so they always tie to the day and feed order decided which count
        // was displayed (TX's 6 over PA's 32). Prefer the deepest warehouse
        // among equal ship dates; the date itself is unchanged.
        if (!best || displayTs < best.displayTsNum ||
            (displayTs === best.displayTsNum && qty > best.qty)) {
          best = {
            totalDays: totalDays,
            qty: qty,
            displayTsNum: displayTs,
            shipByISO: localIsoOf(displayTs),
            displayDate: new Date(displayTs * 1000).toLocaleDateString('en-US', {
              month: 'short',
              day: 'numeric',
              year: 'numeric'
            })
          };
        }
      }
    });

    if (!anyStock && manufacturerStock > 0) {
      var manufacturerTotalDays = manufacturerStockShippingDays;
      var manufacturerDisplayTs = computeBusinessDisplayDate(manufacturerTotalDays, todayTs, config.holidaySet);
      manufacturerBest = {
        totalDays: manufacturerTotalDays,
        qty: manufacturerStock,
        shipDays: manufacturerStockShippingDays,
        source: 'manufacturer',
        manufacturerEstimatedShipDate: manufacturerEstimatedShipDate,
        displayDate: new Date(manufacturerDisplayTs * 1000).toLocaleDateString('en-US', {
          month: 'short',
          day: 'numeric',
          year: 'numeric'
        })
      };

      best = manufacturerBest;
    }

    var treatAsNoConfirmedEta = !anyStock && manufacturerStock <= 0 && anyEta && hasPastEta && !hasFutureEta;
    return {
      path: 'turn14',
      best: best,
      treatAsNoConfirmedEta: treatAsNoConfirmedEta,
      anyStock: anyStock,
      manufacturerStock: manufacturerStock,
      debug: {
        market: marketIsUS ? 'US' : 'CA',
        availabilityEntries: availList,
        best: best,
        anyStock: anyStock,
        manufacturerStock: manufacturerStock,
        manufacturerEstimatedShipDate: manufacturerEstimatedShipDate,
        manufacturerStockShippingDays: manufacturerStockShippingDays,
        manufacturerBest: manufacturerBest,
        anyEta: anyEta,
        hasPastEta: hasPastEta,
        hasFutureEta: hasFutureEta,
        treatAsNoConfirmedEta: treatAsNoConfirmedEta,
        bufferRules: marketIsUS
          ? 'US market uses usInStockBuffer/usOutOfStockBuffer.'
          : 'CA market uses per-warehouse state buffers when ETA is present.'
      }
    };
  }

  function computeVendorFallback(config) {
    var vendorName = (config.vendor || '').toString();
    if (!vendorName) return null;

    function norm(str) {
      return (str || '').toString().trim().toLowerCase();
    }

    var groups = Array.isArray(config.vendorGroups) ? config.vendorGroups : [];
    var assignments = Array.isArray(config.vendorAssignments) ? config.vendorAssignments : [];

    var assignment = assignments.find(function(entry) {
      return entry && norm(extractField(entry, 'vendor_name')) === norm(vendorName);
    });

    function resolveGroupKey(ref) {
      if (!ref) return null;

      var direct = [
        extractField(ref, 'id'),
        extractField(ref, 'gid'),
        extractField(ref, 'key'),
        extractField(ref, 'handle'),
        extractField(ref, 'internal_key')
      ].find(function(val) { return !!val; });
      if (direct) return direct;

      if (ref.reference) {
        var viaReference = resolveGroupKey(ref.reference);
        if (viaReference) return viaReference;
      }

      if (ref.metaobject) {
        var viaMetaobject = resolveGroupKey(ref.metaobject);
        if (viaMetaobject) return viaMetaobject;
      }

      if (ref.value && ref.value !== ref) {
        return resolveGroupKey(ref.value);
      }

      return ref;
    }

    var groupKey = assignment ? resolveGroupKey(extractField(assignment, 'eta_group')) : null;
    var groupEta = assignment ? extractField(assignment, 'group_eta') : null;

    var normAssignmentKeys = [groupKey, groupEta]
      .map(norm)
      .filter(function(val) { return !!val; });

    var group = groups.find(function(entry) {
      var candidates = [
        extractField(entry, 'id'),
        extractField(entry, 'gid'),
        extractField(entry, 'key'),
        extractField(entry, 'internal_key'),
        extractField(entry, 'handle'),
        extractField(entry, 'name')
      ].map(norm);
      return normAssignmentKeys.some(function(assignmentKey) {
        return candidates.some(function(val) { return val && val === assignmentKey; });
      });
    });

    if (!group) return null;

    var behavior = extractField(group, 'behavior');
    var title = extractField(group, 'static_message_title');
    var body = extractField(group, 'static_message_body');
    var checkboxLabel = extractField(group, 'checkbox_label');

    if (body && typeof body === 'object') {
      if (typeof body.value !== 'undefined') {
        body = body.value;
      } else if (typeof body.body !== 'undefined') {
        body = body.body;
      }
    }

    if (checkboxLabel && typeof checkboxLabel === 'object') {
      if (typeof checkboxLabel.value !== 'undefined') {
        checkboxLabel = checkboxLabel.value;
      } else if (typeof checkboxLabel.text !== 'undefined') {
        checkboxLabel = checkboxLabel.text;
      }
    }

    if ((behavior || '').toLowerCase() === 'dynamic eta' || (behavior || '').toLowerCase() === 'dynamic') {
      var etaDays = toNumber(extractField(group, 'fixed_business_days')) + toNumber(extractField(group, 'buffer_days'));
      var etaTs = computeBusinessDisplayDate(etaDays, config.todayTs);
      var displayDate = new Date(etaTs * 1000).toLocaleDateString('en-US', {
        month: 'short',
        day: 'numeric',
        year: 'numeric'
      });
      return {
        path: 'vendor-dynamic',
        badgeState: 'special',
        displayDate: displayDate,
        etaDays: etaDays,
        noteValue: 'Yes — Special order, ship by ' + displayDate + ', final sale',
        ackText: checkboxLabel || null,
        message: panelHtml('special', 'Special order', 'Typically ships in about ' + etaDays + ' business days', 'Estimated to ship by <strong>' + displayDate + '</strong>', '', true),
        debug: {
          vendor: vendorName,
          assignmentKey: groupKey || groupEta,
          behavior: behavior,
          bufferDays: toNumber(extractField(group, 'buffer_days')),
          fixedDays: toNumber(extractField(group, 'fixed_business_days')),
          messageTitle: title,
          messageBody: body,
          assignmentRaw: assignment,
          groupRaw: group,
          mode: 'dynamic'
        }
      };
    }

    var vendorStaticText = ((title || '') + ' ' + (body || '')).toLowerCase();
    var isMadeToOrder = vendorStaticText.indexOf('made to order') !== -1 || vendorStaticText.indexOf('made-to-order') !== -1;
    // Static groups may still carry fixed_business_days (made-to-order
    // "15 to 30 business days" uses 30, the conservative upper bound) so the
    // machine note gets a parseable ship-by date the checkout validation can
    // freshness-check, instead of the old dateless "no ETA".
    var staticDays = toNumber(extractField(group, 'fixed_business_days')) + toNumber(extractField(group, 'buffer_days'));
    var staticShipBy = null;
    if (staticDays > 0) {
      var staticTs = computeBusinessDisplayDate(staticDays, config.todayTs);
      staticShipBy = new Date(staticTs * 1000).toLocaleDateString('en-US', {
        month: 'short',
        day: 'numeric',
        year: 'numeric'
      });
    }
    var staticNoteTail = staticShipBy ? 'ship by ' + staticShipBy : 'no confirmed ship date';
    // v2.17 copy: made to order keeps the vendor group's lead time when its
    // message states one ("Ships in approximately 15 to 30 business days");
    // plain special orders get the short no-date lines
    var leadMatch = String(body || '').replace(/<[^>]+>/g, ' ').match(/ships?\s+in\s+(?:approximately|about|approx\.?)?\s*([^.]+)\./i);
    var staticMessage = isMadeToOrder
      ? panelHtml('madetoorder', 'Made to order', 'Built for you by the manufacturer', leadMatch ? 'Ships in about ' + leadMatch[1].trim() : 'No confirmed ship date yet', '', true)
      : panelHtml('special', 'Special order', 'No confirmed ship date yet', SALES_EMAIL_LINE, '', true);
    return {
      path: 'vendor-static',
      badgeState: isMadeToOrder ? 'madetoorder' : 'special',
      madeToOrder: isMadeToOrder,
      message: staticMessage,
      noDateInChip: true,
      displayDate: staticShipBy || undefined,
      noteValue: (isMadeToOrder ? 'Yes — Made to order, ' : 'Yes — Special order, ') + staticNoteTail + ', final sale',
      title: title || 'Special Order',
      body: body || 'Special order item with no confirmed ship date. Contact sales@raptorracing.com for info.',
      ackText: checkboxLabel || (isMadeToOrder ? 'I understand this item is made to order with no confirmed ship date, and it can\'t be cancelled or refunded.' : null),
      debug: {
        vendor: vendorName,
        assignmentKey: groupKey || groupEta,
        behavior: behavior,
        messageTitle: title,
        messageBody: body,
        assignmentRaw: assignment,
        groupRaw: group,
        mode: 'static'
      }
    };
  }

  // Spec v2.17 6G ("Before you order" panel). Class names are a contract with
  // the theme and cart CSS: eta-badge, eta-badge--{state}, eta-badge__icon,
  // eta-block, eta-nocancel, eta-transit-note. New wrappers (eta-row,
  // eta-count, eta-date) only add structure. Icons are SVG; the old text
  // glyphs (a tick, "!" and "i") are gone. No space before "<" inside these
  // strings, so they survive the theme's inline-script minifier if ever
  // copied into a snippet.
  var RR_ICONS = {
    check: '<svg viewBox="0 0 12 12" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false"><path d="M2.5 6.2 5 8.5l4.5-5"/></svg>',
    box: '<svg viewBox="0 0 12 12" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linejoin="round" aria-hidden="true" focusable="false"><path d="M1.8 4 6 1.8 10.2 4v4.3L6 10.4 1.8 8.3z"/><path d="M1.8 4 6 6.2 10.2 4M6 6.2v4.2"/></svg>',
    clock: '<svg viewBox="0 0 12 12" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" aria-hidden="true" focusable="false"><circle cx="6" cy="6" r="4.3"/><path d="M6 3.6V6l1.6 1"/></svg>',
    cal: '<svg viewBox="0 0 12 12" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" aria-hidden="true" focusable="false"><rect x="1.8" y="2.5" width="8.4" height="7.5" rx="1.2"/><path d="M1.8 5h8.4M4 1.5v2M8 1.5v2"/></svg>',
    wrench: '<svg viewBox="0 0 12 12" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false"><path d="M7.4 2.2a2.2 2.2 0 0 0-2.8 2.7L2 7.5 3.5 9 6.1 6.4a2.2 2.2 0 0 0 2.7-2.8L7.5 4.9 6.6 4.7 6.3 3.8z"/></svg>',
    lock: '<svg viewBox="0 0 16 16" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" aria-hidden="true" focusable="false"><rect x="3" y="7" width="10" height="7" rx="1.5"/><path d="M5.5 7V5a2.5 2.5 0 0 1 5 0v2"/></svg>',
    truck: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false"><path d="M3 7h11v9H3zM14 10h4l3 3v3h-7"/><circle cx="7" cy="17.5" r="1.8"/><circle cx="17" cy="17.5" r="1.8"/></svg>',
    info: '<svg viewBox="0 0 16 16" fill="none" stroke="currentColor" stroke-width="1.6" aria-hidden="true" focusable="false"><circle cx="8" cy="8" r="6.5"/><path d="M8 7.2V11" stroke-linecap="round"/><circle cx="8" cy="5" r=".6" fill="currentColor"/></svg>',
    err: '<svg viewBox="0 0 16 16" aria-hidden="true" focusable="false"><circle cx="8" cy="8" r="7.5" fill="currentColor"/><path d="M8 4.2v4.6" stroke="#fff" stroke-width="1.8" stroke-linecap="round"/><circle cx="8" cy="11.4" r="1" fill="#fff"/></svg>',
    tick: '<svg viewBox="0 0 12 12" aria-hidden="true" focusable="false"><path d="M2.5 6.2 5 8.5l4.5-5" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>',
    caret: '<svg viewBox="0 0 12 12" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" aria-hidden="true" focusable="false"><path d="m3 4.5 3 3 3-3"/></svg>'
  };
  var RR_STATE_ICON = { local: 'check', warehouse: 'check', manufacturer: 'box', oos: 'clock', special: 'cal', madetoorder: 'wrench', preorder: 'cal' };
  var RR_STATE_SHORT = { local: 'In stock', warehouse: 'Warehouse', manufacturer: 'Manufacturer', oos: 'Out of stock', special: 'Special order', madetoorder: 'Made to order', preorder: 'Pre-order' };

  function badgeHtml(state, label) {
    return '<span class="eta-badge eta-badge--' + state + '"><span class="eta-badge__icon" aria-hidden="true">' + (RR_ICONS[RR_STATE_ICON[state]] || RR_ICONS.check) + '</span><span>' + label + '</span></span>';
  }
  function finalSaleHtml() {
    return '<div class="eta-block eta-nocancel">' + RR_ICONS.lock + '<span>Final sale: can\'t be cancelled or refunded once ordered. <a href="/policies/refund-policy">Refund policy</a></span></div>';
  }
  // badge + count on one line, the date line, one small grey line, then the
  // final sale line for special and made-to-order items
  function panelHtml(state, label, count, dateLine, smallLine, finalSale) {
    var h = '<div class="eta-row">' + badgeHtml(state, label) + (count ? '<span class="eta-count">' + count + '</span>' : '') + '</div>';
    if (dateLine) h += '<div class="eta-block eta-date">' + dateLine + '</div>';
    if (smallLine) h += '<div class="eta-block eta-transit-note">' + smallLine + '</div>';
    if (finalSale) h += finalSaleHtml();
    return h;
  }
  var SALES_EMAIL_LINE = 'Email <a href="mailto:sales@raptorracing.com">sales@raptorracing.com</a> for an update';
  var NO_SAME_DAY_NOTE = 'No same-day pickup. Delivery time is extra, based on your location.';
  var DELIVERY_NOTE = 'Delivery time is extra, based on your location.';
  // "Warehouse · by Oct 9" for the phone chip and the sticky bar; states
  // with no date show the name only
  function shortLabel(result) {
    if (!result) return '';
    var state = result.badgeState || 'special';
    var name = RR_STATE_SHORT[state] || 'Shipping info';
    if (state === 'local' && result.sameDayPickup) return 'In stock · pickup today';
    if (state === 'madetoorder' || !result.displayDate || result.noDateInChip) return name;
    return name + ' · by ' + String(result.displayDate).replace(/,\s*\d{4}$/, '');
  }

  function compute(config) {
    var todayTs = config.todayTs || Date.now() / 1000;
    var baseConfig = Object.assign({}, config, { todayTs: todayTs });
    var isCanadaMarket = config.market === 'CA';
    var etaSets = isCanadaMarket ? calendarSets(config.etaCalendar) : null;
    var onHolidaySet = etaSets ? etaSets.on : undefined;
    /* US shoppers (owner, 8 Oct 2026): ship dates skip the calendar's US closed days (usClosed:
       Columbus Day, US Thanksgiving, Christmas...), the way Canadian dates skip the Ontario ones.
       etaSets stays Canada-only: it also drives the Canadian Turn14 cycle rules. */
    if (!isCanadaMarket) {
      var usCal = calendarSets(config.etaCalendar);
      onHolidaySet = usCal ? usCal.us : undefined;
    }
    var defaultAckText = 'I understand the ship date is an estimate and may change.';
    var canadaAckText = 'I understand the ship or pickup date is an estimate and may change.';
    var manufacturerUsAckText = defaultAckText;

    var vendorAttempt = computeVendorFallback({
      vendor: config.vendor,
      vendorGroups: config.vendorGroups,
      vendorAssignments: config.vendorAssignments,
      todayTs: todayTs
    });

    var flagVendor = isFlagStockVendor(config);
    var preferMfr = isPreferMfrVendor(config);
    var warehouseResult = selectWarehouses({
      market: config.market,
      inventoryMap: config.inventoryMap,
      inventoryVariantId: config.inventoryVariantId,
      fulfillmentSources: config.fulfillmentSources,
      todayTs: todayTs,
      holidaySet: onHolidaySet,
      flagStock: flagVendor,
      preferMfr: preferMfr
    });

    var turn14Result = computeTurn14({
      turn14: config.turn14,
      warehouseBuffers: config.warehouseBuffers,
      usInStockBuffer: config.usInStockBuffer,
      usOutOfStockBuffer: config.usOutOfStockBuffer,
      manufacturerStockShippingDays: config.manufacturerStockShippingDays,
      market: config.market,
      todayTs: todayTs,
      etaCalendarSets: etaSets,
      t14Cycle: config.t14Cycle,
      holidaySet: onHolidaySet
    });
    var turn14HasAvailableStock = turn14Result &&
      turn14Result.best &&
      !turn14Result.treatAsNoConfirmedEta &&
      turn14Result.best.qty > 0;
    var useTurn14OverWarehouse = warehouseResult &&
      turn14HasAvailableStock &&
      turn14Result.best.totalDays < warehouseResult.etaDays &&
      !(preferMfr && warehouseResult.isManufacturerInventorySource);

    if (warehouseResult && !useTurn14OverWarehouse) {
      var warehouseDebug = {
        warehouse: warehouseResult.debug,
        turn14: turn14Result && turn14Result.debug,
        vendor: vendorAttempt && vendorAttempt.debug,
        finalPath: 'warehouse'
      };
      var storeText = warehouseResult.isExternalWarehouseSource ? 'external warehouse' : 'warehouse';   /* owner 29 Sept: Turn14 / WheelPros US stock says external warehouse (reverses the 28 Sept E4 merge) */
      if (warehouseResult.displayAsStore) {
        storeText = warehouseResult.storeLink
          ? '<a href="' + warehouseResult.storeLink + '" target="_blank" rel="noopener">Mississauga store</a>'
          : 'Mississauga store';
      }
      var whBadgeState = warehouseResult.isManufacturerInventorySource ? 'manufacturer' : (warehouseResult.displayAsStore ? 'local' : 'warehouse');
      var gvWhQty = warehouseResult.qtyToShowText || String(warehouseResult.qtyToShow);
      var whDate = '<strong>' + warehouseResult.displayDate + '</strong>';
      var warehouseMessage;
      var sameDayPickup = false;

      if (warehouseResult.isManufacturerInventorySource) {
        warehouseDebug.finalPath = 'manufacturer-inventory';
        var manufacturerInventoryVendorName = (config.vendor || 'the manufacturer').toString().trim() || 'the manufacturer';
        var manufacturerInventoryQtyText = warehouseResult.flagStock
          ? 'In stock at ' + escapeHtml(manufacturerInventoryVendorName)
          : '<b>' + gvWhQty + '</b> available at ' + escapeHtml(manufacturerInventoryVendorName);
        warehouseMessage = isCanadaMarket
          ? panelHtml('manufacturer', 'Manufacturer stock', manufacturerInventoryQtyText, 'Ships or ready for pickup by ' + whDate, NO_SAME_DAY_NOTE)
          : panelHtml('manufacturer', 'Manufacturer stock', manufacturerInventoryQtyText, 'Ships direct from the manufacturer by ' + whDate, DELIVERY_NOTE);
      } else if (isCanadaMarket && warehouseResult.displayAsStore) {
        sameDayPickup = true;
        warehouseMessage = panelHtml('local', 'In stock locally', '<b>' + gvWhQty + '</b> in our ' + storeText, 'Same-day pickup, or ships by ' + whDate, DELIVERY_NOTE);
      } else if (isCanadaMarket) {
        warehouseMessage = panelHtml('warehouse', 'Warehouse stock', '<b>' + gvWhQty + '</b> in our ' + storeText, 'Ships or ready for pickup by ' + whDate, NO_SAME_DAY_NOTE);
      } else {
        warehouseMessage = panelHtml(whBadgeState, whBadgeState === 'local' ? 'In stock locally' : 'Warehouse stock', '<b>' + gvWhQty + '</b> in our ' + storeText, 'Ships by ' + whDate, DELIVERY_NOTE);
      }

      return {
        path: warehouseResult.isManufacturerInventorySource ? 'manufacturer-inventory' : 'warehouse',
        badgeState: whBadgeState,
        sameDayPickup: sameDayPickup,
        qtyToShow: warehouseResult.qtyToShow,
        displayDate: warehouseResult.displayDate,
        noteValue: 'Yes — ' + (whBadgeState === 'local' ? 'In stock locally' : (whBadgeState === 'manufacturer' ? 'Manufacturer stock' : (warehouseResult.isExternalWarehouseSource ? 'Ext. warehouse stock' : 'Warehouse stock'))) + ', ship by ' + warehouseResult.displayDate,
        ackText: warehouseResult.isManufacturerInventorySource && !isCanadaMarket ? manufacturerUsAckText : (isCanadaMarket ? canadaAckText : defaultAckText),
        message: warehouseMessage,
        debug: warehouseDebug
      };
    }

    if (turn14Result && turn14Result.best && !turn14Result.treatAsNoConfirmedEta) {
      var turn14Debug = {
        warehouse: warehouseResult && warehouseResult.debug,
        turn14: turn14Result.debug,
        vendor: vendorAttempt && vendorAttempt.debug,
        finalPath: turn14Result.best.source === 'manufacturer' ? 'turn14-manufacturer' : 'turn14'
      };
      var isManufacturerStock = turn14Result.best.source === 'manufacturer';
      var isOutOfStock = !(turn14Result.best.qty > 0);
      var t14Date = '<strong>' + turn14Result.best.displayDate + '</strong>';
      var message;
      // OOS: displayDate is the RESTOCK ESTIMATE plus the same state shipping
      // buffers an in-stock unit gets, i.e. a projected SHIP date (Stathis,
      // 7 Aug), so the line says "Estimated to ship by".
      if (isOutOfStock) {
        message = panelHtml('oos', 'Out of stock', 'Awaiting restock', 'Estimated to ship by ' + t14Date, 'Order now to reserve yours.');
      } else if (isManufacturerStock) {
        var manufacturerVendorName = (config.vendor || 'the manufacturer').toString().trim() || 'the manufacturer';
        var mfrCount = '<b>' + (turn14Result.best.qty > 50 ? '50+' : String(turn14Result.best.qty)) + '</b> available at ' + escapeHtml(manufacturerVendorName);
        message = isCanadaMarket
          ? panelHtml('manufacturer', 'Manufacturer stock', mfrCount, 'Ships or ready for pickup by ' + t14Date, NO_SAME_DAY_NOTE)
          : panelHtml('manufacturer', 'Manufacturer stock', mfrCount, 'Ships direct from the manufacturer by ' + t14Date, DELIVERY_NOTE);
      } else {
        var t14Count = '<b>' + (turn14Result.best.qty > 10 ? '10+' : String(turn14Result.best.qty)) + '</b> in our external warehouse';
        message = isCanadaMarket
          ? panelHtml('warehouse', 'Warehouse stock', t14Count, 'Ships or ready for pickup by ' + t14Date, NO_SAME_DAY_NOTE)
          : panelHtml('warehouse', 'Warehouse stock', t14Count, 'Ships by ' + t14Date, DELIVERY_NOTE);
      }
      var turn14NoteValue = isOutOfStock
        ? 'Yes — Out of stock, ship by ' + turn14Result.best.displayDate + ' (after restock)'
        : (isManufacturerStock
            ? 'Yes — Manufacturer stock, ship by ' + turn14Result.best.displayDate
            : 'Yes — Ext. warehouse stock, ship by ' + turn14Result.best.displayDate);
      return {
        path: 'turn14',
        badgeState: isOutOfStock ? 'oos' : (isManufacturerStock ? 'manufacturer' : 'warehouse'),
        displayDate: turn14Result.best.displayDate,
        noteValue: turn14NoteValue,
        ackText: isOutOfStock
          ? 'I understand this item is out of stock and the ship date may change.'
          : (isManufacturerStock && !isCanadaMarket ? manufacturerUsAckText : (isCanadaMarket ? canadaAckText : defaultAckText)),
        message: message,
        debug: turn14Debug
      };
    }

    /* flagged brand reads 0 at Manufacturer Inventory and nothing is in stock
       anywhere else: say so. The brand's vendor ETA group still decides the
       date and terms (Powerflex, Group E: no confirmed date, final sale). */
    if (flagVendor && flagStockIsOut(config)) {
      var flagName = escapeHtml((config.vendor || 'the manufacturer').toString().trim() || 'the manufacturer');
      var flagDate = vendorAttempt && vendorAttempt.path === 'vendor-dynamic' && vendorAttempt.displayDate ? vendorAttempt.displayDate : null;
      var flagFinal = !flagDate;
      return {
        path: 'flag-oos',
        badgeState: 'oos',
        displayDate: flagDate,
        noDateInChip: !flagDate,
        noteValue: 'Yes — Out of stock at ' + (config.vendor || 'the manufacturer') + (flagDate ? ', ship by ' + flagDate : ', no confirmed ship date'),
        ackText: flagFinal
          ? 'I understand this item is out of stock with no confirmed ship date, and it can\'t be cancelled or refunded.'
          : 'I understand this item is out of stock and the ship date may change.',
        message: panelHtml('oos', 'Out of stock', 'Out of stock at ' + flagName,
          flagDate ? 'Estimated to ship by <strong>' + flagDate + '</strong>' : 'No confirmed ship date yet',
          flagDate ? 'Order now to reserve yours.' : SALES_EMAIL_LINE,
          flagFinal),
        debug: { warehouse: warehouseResult && warehouseResult.debug, turn14: turn14Result && turn14Result.debug, vendor: vendorAttempt && vendorAttempt.debug, finalPath: 'flag-oos' }
      };
    }

    var vendorResult = vendorAttempt;

    if (vendorResult) {
      var vendorDebug = {
        warehouse: warehouseResult && warehouseResult.debug,
        turn14: turn14Result && turn14Result.debug,
        vendor: vendorResult.debug,
        finalPath: vendorResult.path
      };
      if (vendorResult.path === 'vendor-dynamic') {
        return Object.assign({}, vendorResult, {
          ackText: vendorResult.ackText || 'I understand this is a special order: the ship date may change and it can\'t be cancelled or refunded.',
          debug: vendorDebug
        });
      }
      return Object.assign({}, vendorResult, {
        isSpecialOrder: true,
        ackText: vendorResult.ackText || 'I understand this is a special order with no confirmed ship date, and it can\'t be cancelled or refunded.',
        debug: vendorDebug
      });
    }

    var hasTurn14Partnumber = config.turn14 && (config.turn14.partnumber || config.turn14.partNumber || config.turn14.part_number);
    var unknownMessage = panelHtml('special', 'Special order', 'No confirmed ship date yet', SALES_EMAIL_LINE, '', true);
    return {
      path: 'unknown',
      badgeState: 'special',
      noteValue: 'Yes — Special order, no confirmed ship date, final sale',
      ackText: 'I understand this is a special order with no confirmed ship date, and it can\'t be cancelled or refunded.',
      message: unknownMessage,
      noDateInChip: true,
      debug: {
        warehouse: warehouseResult && warehouseResult.debug,
        turn14: turn14Result && turn14Result.debug,
        vendor: vendorAttempt && vendorAttempt.debug,
        finalPath: 'unknown'
      }
    };
  }


  // ---------------------------------------------------------------------
  // Quantity-aware wrapper. Builds a unified stock pool — theme fulfillment
  // sources (store/warehouses) PLUS Turn14 warehouses PLUS Turn14
  // manufacturer stock — sorted by ETA, then walks it until the requested
  // quantity is covered. The SLOWEST source needed governs the line's ETA,
  // computed natively by masking faster sources out of the engine's inputs.
  // If the whole pool cannot cover the quantity, falls through to the
  // vendor/special-order path and flags the true shortfall.
  // ---------------------------------------------------------------------
  function computeForQuantity(config, quantity) {
    var qtyRequested = Math.max(1, toNumber(quantity) || 1);
    var base = compute(config);
    if (qtyRequested <= 1) return base;

    var todayTs = config.todayTs || Date.now() / 1000;
    var sources = Array.isArray(config.fulfillmentSources) ? config.fulfillmentSources : [];

    // --- pool part 1: theme fulfillment sources ---
    var pool = [];
    var preferMfrQ = isPreferMfrVendor(config);
    var etaSetsQ = config.market === 'CA' ? calendarSets(config.etaCalendar) : null;
    var usCalQ = config.market === 'CA' ? null : calendarSets(config.etaCalendar);
    var holidaysQ = etaSetsQ ? etaSetsQ.on : (usCalQ ? usCalQ.us : undefined);
    var wh = selectWarehouses({
      market: config.market,
      inventoryMap: config.inventoryMap,
      inventoryVariantId: config.inventoryVariantId,
      fulfillmentSources: config.fulfillmentSources,
      todayTs: todayTs,
      holidaySet: holidaysQ,
      flagStock: isFlagStockVendor(config),
      preferMfr: preferMfrQ
    });
    if (wh && wh.candidates) {
      wh.candidates.forEach(function(c) {
        pool.push({
          kind: 'wh',
          days: c.etaDays,
          qty: c.qty,
          idx: c.idx,
          rank: sourceRank(c),
          label: c.displayAsStore ? 'in our store'
            : c.isManufacturerInventorySource ? 'at the manufacturer'
            : c.isExternalWarehouseSource ? 'in our external warehouse'
            : 'in our warehouse'
        });
      });
    }

    // --- pool part 2: Turn14 warehouses (probe each entry alone so the
    //     engine's own buffer math prices its ETA) ---
    var t14Obj = config.turn14 || {};
    var availEntries = Array.isArray(t14Obj.availability) ? t14Obj.availability : [];
    var t14Common = {
      warehouseBuffers: config.warehouseBuffers,
      usInStockBuffer: config.usInStockBuffer,
      usOutOfStockBuffer: config.usOutOfStockBuffer,
      manufacturerStockShippingDays: config.manufacturerStockShippingDays,
      market: config.market,
      todayTs: todayTs,
      etaCalendarSets: etaSetsQ,
      t14Cycle: config.t14Cycle,
      holidaySet: holidaysQ
    };
    availEntries.forEach(function(entry, i) {
      if (!entry) return;
      var q = toNumber(entry.Quantity || entry.qty);
      if (q <= 0) return;
      var probe = computeTurn14(Object.assign({}, t14Common, {
        turn14: { availability: [entry] }
      }));
      if (probe && probe.best && !probe.treatAsNoConfirmedEta) {
        pool.push({ kind: 't14', days: probe.best.totalDays, qty: q, entryIndex: i, label: 'in our external warehouse' });
      }
    });

    // --- pool part 3: Turn14 manufacturer stock ---
    var mfrUnits = toNumber(
      t14Obj.manufacturerStock || t14Obj.ManufacturerStock || t14Obj.manufacturer_stock
    );
    if (mfrUnits > 0) {
      var mfrProbe = computeTurn14(Object.assign({}, t14Common, {
        turn14: {
          availability: [{ Quantity: 0 }],
          manufacturerStock: mfrUnits,
          manufacturerEstimatedShipDate: t14Obj.manufacturerEstimatedShipDate || t14Obj.ManufacturerEstimatedShipDate || null
        }
      }));
      if (mfrProbe && mfrProbe.best) {
        pool.push({ kind: 'mfr', days: mfrProbe.best.totalDays, qty: mfrUnits, label: 'at the manufacturer' });
      }
    }

    // No real stock anywhere: made-to-order / special-order items need no
    // quantity treatment — the base result already says it all.
    if (!pool.length) return base;

    // Equal-day ordering (v6.7): theme sources, then Turn14, then
    // manufacturer (the push order a stable sort already preserved), and
    // among equal-day Turn14 entries the deepest first, so the warehouse
    // that wins the single-unit ranking also fills multi-unit orders first
    // and the allocation text stays consistent with the product-page count.
    function poolKindRank(k) { return k === 'wh' ? 0 : k === 't14' ? 1 : 2; }
    pool.sort(function(a, b) {
      if (preferMfrQ) {
        var pa = a.kind === 'wh' ? a.rank : 2, pb = b.kind === 'wh' ? b.rank : 2;
        if (pa !== pb) return pa - pb;
      }
      if (a.days !== b.days) return a.days - b.days;
      var ka = poolKindRank(a.kind), kb = poolKindRank(b.kind);
      if (ka !== kb) return ka - kb;
      if (ka === 1 && a.qty !== b.qty) return b.qty - a.qty;
      return 0;
    });

    var cumulative = 0;
    var needed = [];
    for (var i = 0; i < pool.length; i++) {
      cumulative += pool[i].qty;
      needed.push(pool[i]);
      if (cumulative >= qtyRequested) break;
    }

    var flat = buildInventoryMap(config.inventoryMap, config.inventoryVariantId);

    function buildAllocation() {
      var remaining = qtyRequested;
      var allocs = [];
      needed.forEach(function(c) {
        var take = Math.min(c.qty, remaining);
        remaining -= take;
        if (take <= 0) return;
        var last = allocs[allocs.length - 1];
        if (last && last.label === c.label) { last.take += take; }
        else { allocs.push({ take: take, label: c.label }); }
      });
      return allocs;
    }

    function applyAllocation(result) {
      var allocs = buildAllocation();
      var html = allocs.map(function(a) { return '<b>' + a.take + '</b> ' + a.label; }).join(' + ');
      var text = allocs.map(function(a) { return a.take + ' ' + a.label; }).join(' + ');
      var qtySentence = /<b>\d+\+?<\/b>[^<]*/;
      var applied = false;
      var governingKind = needed[needed.length - 1].kind;
      if (result.message && governingKind !== 'mfr' && qtySentence.test(result.message)) {
        result.message = result.message.replace(qtySentence, html);
        applied = true;
      } else if (result.message) {
        result.message += '<div class="eta-block">' + html + '</div>';
        applied = true;
      }
      result.quantitySplit = {
        requested: qtyRequested,
        immediate: needed.length > 1 ? needed[0].qty : qtyRequested,
        sources: needed.map(function(c) { return { kind: c.kind, qty: c.qty, etaDays: c.days }; })
      };
      result.quantityAllocation = { html: html, text: text, applied: applied };
      return result;
    }

    if (cumulative >= qtyRequested) {
      if (needed.length === 1) return base;

      var governing = needed[needed.length - 1];

      // Mask theme locations consumed by faster wh entries (or all of them
      // when a Turn14/manufacturer source governs).
      var masked = {};
      for (var key in flat) {
        if (Object.prototype.hasOwnProperty.call(flat, key)) masked[key] = flat[key];
      }
      needed.forEach(function(c, idx2) {
        if (c.kind !== 'wh') return;
        if (idx2 === needed.length - 1) return; // governing keeps its stock
        var src2 = sources[c.idx];
        var locId = src2 ? extractField(src2, 'shopify_location_id') : null;
        if (locId != null) masked[String(locId)] = 0;
      });
      if (governing.kind !== 'wh') {
        for (var key2 in masked) {
          if (Object.prototype.hasOwnProperty.call(masked, key2)) masked[key2] = 0;
        }
      }

      // Filter Turn14 inputs so nothing faster than the governing source can
      // win the engine's internal ranking.
      var turn14Adjusted = null;
      if (governing.kind === 'mfr') {
        turn14Adjusted = Object.assign({}, t14Obj, { availability: [{ Quantity: 0 }] });
      } else {
        var keepIndexes = {};
        pool.forEach(function(c) {
          if (c.kind !== 't14') return;
          if (c.days >= governing.days || c === governing) keepIndexes[c.entryIndex] = true;
        });
        if (governing.kind === 't14') keepIndexes[governing.entryIndex] = true;
        var filtered = availEntries.filter(function(entry, i3) { return keepIndexes[i3]; });
        turn14Adjusted = Object.assign({}, t14Obj, {
          availability: filtered,
          manufacturerStock: 0,
          ManufacturerStock: 0,
          manufacturer_stock: 0
        });
        if (governing.kind === 'wh') {
          // Governing theme source: drop faster Turn14 entries entirely; the
          // remaining (slower) ones must not outrank it either — compute
          // prefers Turn14 only when strictly faster, so this is safe.
          turn14Adjusted.availability = filtered.filter(function(entry) {
            var q3 = toNumber(entry && (entry.Quantity || entry.qty));
            return q3 > 0;
          });
        }
      }

      var governed = compute(Object.assign({}, config, {
        inventoryMap: { locations: masked },
        turn14: turn14Adjusted,
        todayTs: todayTs
      }));
      return applyAllocation(governed);
    }

    // Requested quantity exceeds ALL known stock: vendor/special-order path
    // with the true availability count.
    var emptied = {};
    for (var key4 in flat) {
      if (Object.prototype.hasOwnProperty.call(flat, key4)) emptied[key4] = 0;
    }
    var fallback = compute(Object.assign({}, config, {
      inventoryMap: { locations: emptied },
      turn14: null,
      todayTs: todayTs
    }));
    fallback.quantityShortfall = { requested: qtyRequested, available: cumulative };
    fallback.noteValue = fallback.noteValue + ' (only ' + cumulative + ' of ' + qtyRequested + ' in stock now)';
    return fallback;
  }


  window.RaptorEta = {
  compute: compute,
  computeForQuantity: computeForQuantity,
  icons: RR_ICONS,
  stateIcon: RR_STATE_ICON,
  badgeHtml: badgeHtml,
  shortLabel: shortLabel,
  helpers: {
    parseJSONSafe: parseJSONSafe,
    toNumber: toNumber,
    bumpWeekend: bumpWeekend,
    countBusinessDaysBetween: countBusinessDaysBetween,
    computeDisplayDate: computeDisplayDate,
    computeBusinessDisplayDate: computeBusinessDisplayDate,
    torontoParts: torontoParts,
    calendarSets: calendarSets,
    resolveShipDay: resolveShipDay,
    computeT14CycleShip: computeT14CycleShip
  }
};
})();
